import { DialogButtonsConfig, InitParams, Partner } from "types";
import { init } from "./init";

window.tt = {
    config: undefined,
};

function getStyleSheetHref() {
    const styleSheetHref = process.env.STYLE_SHEET_HREF as string | "vercel-url";
    if (styleSheetHref === "vercel-url") {
        const domain = process.env.VERCEL_URL;
        return `https://${domain}/v2/index.css`;
    }
    return styleSheetHref;
}

function getPartner(partnerSearchParam?: string): Partner {
    if (!partnerSearchParam) return null;
    if (partnerSearchParam === "openbay") return "openbay";
}

function getDialogButtonsConfig(hideDialogButtonsSearchParam?: string): DialogButtonsConfig {
    let config = { hideTireButton: false, hideScheduleButton: false };
    if (hideDialogButtonsSearchParam) {
        if (hideDialogButtonsSearchParam === "true") {
            return { hideTireButton: true, hideScheduleButton: true };
        }
        if (hideDialogButtonsSearchParam.includes("tire")) {
            config = { ...config, hideTireButton: true };
        }
        if (hideDialogButtonsSearchParam.includes("schedule")) {
            config = { ...config, hideScheduleButton: true };
        }
    }
    return config;
}

export function loadAndInitialize() {
    const styleSheet = document.createElement("link");
    const styleSheetHref = getStyleSheetHref();
    styleSheet.setAttribute("href", styleSheetHref);
    styleSheet.setAttribute("rel", "stylesheet");
    document.getElementsByTagName("head")[0].appendChild(styleSheet);

    const script = document.getElementById("ttIntegrationScript");
    const searchParams = new URLSearchParams(script.getAttribute("src").split("?")[1]);
    const dealerId = searchParams.get("dealerId");
    const storeId = searchParams.get("storeId");
    const dialogButtons = getDialogButtonsConfig(searchParams.get("hideDialogButtons"));
    const partner = getPartner(searchParams.get("partner"));
    let initParams: InitParams = { dealerId, dialogButtons };
    if (storeId) initParams = { ...initParams, storeId };
    if (partner) initParams = { ...initParams, partner };
    init(initParams);
}

window.addEventListener("load", loadAndInitialize);
